import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setCustomFilterGroupValue } from "./actions";
import { SetCustomFilterGroup } from "./request";

export class SetCustomFilterGroupHandler extends StoreBaseHandler {
  async handle(request: SetCustomFilterGroup) {
    try {
      this.store.dispatch(setCustomFilterGroupValue(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
